import React from "react";
import { Box, TextField, Typography, Modal } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SaveButton, CloseButton } from "../../../common/Buttons";

const ModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  boxShadow: 24,
  padding: theme.spacing(4),
}));

function CreateItemModal({ table, handleAddItem }) {
  return (
    <Modal open={true}>
      <ModalContainer>
        <Typography variant="h6" component="h2" mb={3}>
          Item 추가
        </Typography>
        <TextField
          label="Item 이름"
          fullWidth
          autoFocus
          name="item_name"
          onChange={(e) =>
            table.setCreatingRow({
              ...table.getState().creatingRow,
              item_name: e.target.value,
            })
          }
          sx={{ mb: 3 }}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <SaveButton
            onClick={() =>
              handleAddItem({ values: table.getState().creatingRow, table })
            }
          />
          <CloseButton
            variant="outlined"
            onClick={() => table.setCreatingRow(null)}
            color="inherit"
          />
        </Box>
      </ModalContainer>
    </Modal>
  );
}

export default CreateItemModal;
